(function () {
  var params = new URLSearchParams(window.location.search);
  var giftIntent = params.get("gift_intent");
  var recipient = params.get("recipient");
  if (!giftIntent || !recipient) return;
  if ((window.location.pathname || "").indexOf("/products/") === -1) return;

  var buyer = params.get("buyer");
  var virtualGiftProduct = params.get("virtual_gift_product");
  var sourceContext = params.get("source_context");

  function lineProperties() {
    var properties = {};
    if (buyer) properties._unonight_user_id = buyer;
    if (recipient) properties._unonight_recipient_user_id = recipient;
    if (giftIntent) properties._unonight_gift_intent_id = giftIntent;
    if (virtualGiftProduct) properties._unonight_virtual_gift_product_id = virtualGiftProduct;
    if (sourceContext) properties._unonight_source_context = sourceContext;
    return properties;
  }

  function mergeProperties(existing) {
    var merged = Object.assign({}, existing || {}, lineProperties());
    return merged;
  }

  function patchFetch() {
    if (window.__unonightGiftFetchPatched) return;
    window.__unonightGiftFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : input && input.url ? input.url : "";
        if (url.indexOf("/cart/add") !== -1 && init && init.body) {
          var body = init.body;
          if (typeof body === "string") {
            var payload = JSON.parse(body);
            if (payload.items && Array.isArray(payload.items)) {
              payload.items = payload.items.map(function (item) {
                return Object.assign({}, item, {
                  properties: mergeProperties(item.properties)
                });
              });
              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            } else if (payload.id) {
              payload.properties = mergeProperties(payload.properties);
              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            }
          }
        }
      } catch (error) {
        console.warn("Unonight gift product bridge fetch patch skipped", error);
      }
      return originalFetch.call(this, input, init);
    };
  }

  function patchProductForms() {
    document.querySelectorAll("form[action*='/cart/add']").forEach(function (form) {
      if (form.dataset.unonightGiftPatched) return;
      form.dataset.unonightGiftPatched = "1";
      form.addEventListener("submit", function () {
        var props = lineProperties();
        Object.keys(props).forEach(function (key) {
          var existing = form.querySelector('input[name="properties[' + key + ']"]');
          if (existing) {
            existing.value = props[key];
            return;
          }
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[" + key + "]";
          input.value = props[key];
          form.appendChild(input);
        });
      });
    });
  }

  function init() {
    patchFetch();
    patchProductForms();
    document.addEventListener("shopify:section:load", patchProductForms);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
